import React,{useEffect,useState} from 'react';
import Button from "components/Button/Button";
//import Form from 'react-bootstrap/Form';
import { Form, Dropdown, SplitButton } from 'react-bootstrap';
// , DropdownButton
import './style.css';
import axios from "axios";
//import { NavLink } from "react-router-dom";
import { Link } from "react-router-dom";
//import {user_access_level} from 'Api/Api';
import { local_routes } from 'utils/Routes';
import ConfirmModal from 'components/ContactReportModal/ConfirmModal';
import Modal from "react-bootstrap/Modal";
import ShareAccessModalButton from 'components/Modals/ShareAccessModalButton';
import DownloadAssetsButton from 'components/DownloadAssetsButton/DownloadAssetsButton';
import { withRouter } from "react-router-dom";
import { setLocalStorageSubVal } from "utils/Helper.js";
import ReactTooltip from 'react-tooltip';


function EventListV2 (props) {
    const [isPublishedChecked, setIsPublishedChecked] = useState(false); // published
    const [edit_dropdown_option_index, setEditDropdownOptionIndex] = useState(0);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    //const [workspace_base_url, setWorkspaceBaseUrl] = useState('');
    const [assets_array, setAssetsArray] = useState([]);
    const [source_text, setSourceText] = useState('');
    //const [assets_array, setAssetsArray] = useState([]);
    //const [event_indicator, setEventIndicator] = useState('');
    //const { data } = props;
    
    //const [publish_dropdown_options,setPublishDropdownOptions] = useState([]);
    //const [publish_dropdown_option_index, setPublishDropdownOptionIndex] = useState(0);

    /*
    let all_publish_dropdown_options = {
        workspace_admin: [
            {
                title: 'Team View',
                //status_code: 1,
                public_status: 'private',
                icon: <i className="fa fa-user-circle"/>,
                tooltip: 'Event page available to anybody in your Team'
            },
            {
                title: 'Private',
                //status_code: 1,
                public_status: 'super_private',
                icon: <i className="fa fa-lock"/>,
                tooltip: 'Event page only available to you, Team Admins, and selected users'
            },
            {
                title: 'Public',
                //status_code: 1,
                public_status: 'public',
                icon: <i className="fa fa-users"/>,
                tooltip: 'Event page available to anybody on PechaKucha.com'
            }
        ],
        workspace_normal: [
            {
                title: 'Team View',
                //status_code: 1,
                public_status: 'private',
                icon: <i className="fa fa-user-circle"/>,
                tooltip: 'Event page available to anybody in your Team'
            },
            {
                title: 'Private',
                //status_code: 1,
                public_status: 'super_private',
                icon: <i className="fa fa-lock"/>,
                tooltip: 'Event page only available to you, Team Admins, and selected users'
            }
        ],
        pro: [
            {
                title: 'Public',
                //status_code: 1,
                public_status: 'public',
                icon: <i className="fa fa-users"/>,
                tooltip: 'Event page available to anybody on PechaKucha.com'
            },
            {
                title: 'Private',
                //status_code: 1,
                public_status: 'super_private',
                icon: <i className="fa fa-lock"/>,
                tooltip: 'Event page only available to you and selected users'
            },
        ],
        normal: [
            {
                title: 'Public',
                //status_code: 1,
                public_status: 'public',
                icon: <i className="fa fa-users"/>,
                tooltip: 'Event page available to anybody on PechaKucha.com'
            }
        ]
    }
    */

    let edit_dropdown_options = [
        {
            otherpage: 'description',
            title: 'Edit Description'
        },
        {
            otherpage: 'venue',
            title: 'Edit Venue'
        },
        {
            otherpage: 'presenters',
            title: 'Edit Presenters'
        },
    ];
    if (props.user_access_level === 'admin') {
        if (props.event_info.zoom_webinar_id) {
            edit_dropdown_options.push({
                otherpage: 'registration',
                title: 'Registration'
            })
        }


        edit_dropdown_options.push({
            otherpage: 'runofshow',
            title: 'Run Of Show'
        })
    }

    useEffect(() => {
        if (props.event_info.status_code === 1) {
            setIsPublishedChecked(true);
        } else {
            setIsPublishedChecked(false);
        }
        
        // this logic moved into ShareAccessModalButton
        /*
        if (props.workspace_base_url) {
            if (props.organization_user_access_level === 'admin' || props.user_access_level === 'admin') {
                setPublishDropdownOptions(all_publish_dropdown_options['workspace_admin']);
                let tmp_publish_dropdown_option_index = all_publish_dropdown_options['workspace_admin'].findIndex(item => {
                    if (item.public_status === props.event_info.public_status) {
                        return true;
                    }
                });
                if (tmp_publish_dropdown_option_index >= 0) {
                    setPublishDropdownOptionIndex(tmp_publish_dropdown_option_index);
                }
            } else {
                setPublishDropdownOptions(all_publish_dropdown_options['workspace_normal']);
                let tmp_publish_dropdown_option_index = all_publish_dropdown_options['workspace_normal'].findIndex(item => {
                    if (item.public_status === props.event_info.public_status) {
                        return true;
                    }
                });
                if (tmp_publish_dropdown_option_index >= 0) {
                    setPublishDropdownOptionIndex(tmp_publish_dropdown_option_index);
                }
            }
        } else {
            // normal public view
            setPublishDropdownOptions(all_publish_dropdown_options['normal']);
            let tmp_publish_dropdown_option_index = all_publish_dropdown_options['normal'].findIndex((item,index) => {
                if (item.public_status === props.event_info.public_status) {
                    return index;
                }
            });
            if (tmp_publish_dropdown_option_index >= 0) {
                setPublishDropdownOptionIndex(tmp_publish_dropdown_option_index);
            }
        }
        */
        
        /*
        if (props.workspace_base_url) {
            setWorkspaceBaseUrl(props.workspace_base_url)
        }
        */

        if (props.event_info.source_info && props.event_info.source_info.entity_name) {
            setSourceText(props.event_info.source_info.entity_name);
        } else if (props.event_info.locations_text) {
            setSourceText(props.event_info.locations_text);
        } else if (props.event_info.channels_text) {
            setSourceText(props.event_info.channels_text);
        } else if (props.org_info) {
            setSourceText(props.org_info.entity_name);
        }

        let assets_array = [];
        // all users get this for now
        if (props.event_info.event_pptx_url) {
            let asset_download_obj = {
                asset_url: props.event_info.event_pptx_url,
                dropdown_option: <i className="fa fa-file-powerpoint-o"> Pptx (Powerpoint) File</i>
            }
            assets_array.push(asset_download_obj);
        }

        setAssetsArray(assets_array);


    }, [props])

    function onClickDeleteEvent () {
        console.log("onClickDeleteEvent");
        setShowConfirmModal(true);
    }

    function onClickEditDropdown (edit_dropdown_option_index) {
        console.log("onClickEditDropdown",edit_dropdown_option_index);
        setEditDropdownOptionIndex(edit_dropdown_option_index);
        props.history.push({
            pathname: `${props.workspace_base_url}${local_routes.manageevent}/${props.event_info.entity_uuid}/${edit_dropdown_options[edit_dropdown_option_index].otherpage}`,
            data: {
                source: {
                    referrer: props.referrer
                }
            }
        });
    }

    // Toogles modal show
    function showEmbedModal () {
        setShowConfirmModal(true);
        //this.setState({ showEmbedModal: true });
        //return null;
    }
    // Toogles modal hide
    function hideConfirmModal () {
        setShowConfirmModal(false);
        //this.setState({ showEmbedModal: false });
        //return null;
    }

    function OnConfirmDelete () {
        console.log("OnConfirmDelete",props.event_info.entity_uuid);
        setShowConfirmModal(false);
        props.OnDeleteEvent(props.event_info.entity_uuid,props.index);
    }

    function onPublishedCheckboxSelect() {
        if (isPublishedChecked === true) {
            props.togglePublish(false, props.event_info, props.index)
        }
        else {
            props.togglePublish(true, props.event_info, props.index)
        }
        setIsPublishedChecked(!isPublishedChecked);
    }
    
    function leaveTeamWorkspace () {
      console.log("leaveTeamWorkspace");
      axios.defaults.headers.common['X-PK-Organization'] = '';
      setLocalStorageSubVal("PersistentUserState",'org_friendly_url','');
      setLocalStorageSubVal("PersistentUserState",'org_account_level','');
      setLocalStorageSubVal("PersistentUserState",'org_name','');
      setLocalStorageSubVal("PersistentUserState",'org_uuid','');
    }

    return (
        <tr>
            <td className="upComingEventName">
                   {( props.event_info.public_status === 'public' && props.event_info.organizations_uuid) ?
                      <React.Fragment>
                        {props.event_info.status_code === 1 ?
                            <React.Fragment>
                              <Link to={`${props.workspace_base_url}${local_routes.events}/${props.event_info.friendly_url}`}
                                  style={{ marginBottom: '3px', color: '#007bff' }}>
                                  <span data-tip="Click to visit Team Event page" className="label-value">
                                      {props.event_info.entity_name}
                                      <ReactTooltip />
                                  </span>
                              </Link>
                              <br/>
                              <a onClick={leaveTeamWorkspace} href={`${local_routes.events}/${props.event_info.friendly_url}`}
                                  style={{ color: '#007bff' }}>
                                  <span data-tip="Click to leave your Team workspace, and visit the *Public* Event page" className="label-value">
                                      {props.event_info.entity_name}<span style={{ verticalAlign: "super", fontSize: "x-small", color: "#E50114" }}> PUBLIC</span>
                                      <ReactTooltip />
                                  </span>
                              </a>
                            </React.Fragment>
                            :
                            <span data-tip="Event in 'Draft' mode - page not available" className="label-value">
                                {props.event_info.entity_name}
                                <ReactTooltip />
                            </span>
                        }
                      </React.Fragment>
                      :
                      <React.Fragment>
                        {props.event_info.status_code === 1 ?
                            <Link to={`${props.workspace_base_url}${local_routes.events}/${props.event_info.friendly_url}`}
                                style={{ color: '#007bff' }}>
                                <span data-tip="Click to visit Event page" className="label-value">
                                    {props.event_info.entity_name}
                                    <ReactTooltip />
                                </span>
                            </Link>
                            :
                            <span data-tip="Event in 'Draft' mode - page not available" className="label-value">
                                {props.event_info.entity_name}
                                <ReactTooltip />
                            </span>
                        }
                      </React.Fragment>
                    }

                {/*
                {(props.event_info.status_code === 1) ?
                    <NavLink to={`${workspace_base_url}${local_routes.events}/${props.event_info.friendly_url}`}>
                        <div style={{color: '#007bff' }} className="React__checkbox">
                            <span className="label-value">{props.event_info.entity_name}</span>
                        </div>
                    </NavLink>
                :
                    <div style={{color: '#212529' }} className="React__checkbox">
                        <span className="label-value">{props.event_info.entity_name}</span>
                    </div>
    
                }
                */}
            </td>
            <td className="pkDate">
                {new Date(props.event_info.start_time * 1000).toLocaleDateString()}
            </td>
            <td className="pkDate">
                {source_text}
            </td>
            <td className="">
                <div className="">
                    <Form>
                        <Form.Group className="mb-0">
                            <div className="">
                                <label className="check-box">
                                    <input type="checkbox"
                                        disabled={false}
                                        className="React__checkbox--input"
                                        name="public_status"
                                        onChange={() => onPublishedCheckboxSelect('isPublishedChecked')}
                                        checked={isPublishedChecked} />
                                    <span className="React__checkbox--span" />
                                    <span className="label-value"></span>
                                </label>                           
 
                            </div>
                        </Form.Group>
                    </Form>
                </div>
            </td>

            <td className="">
            {/*
                { publish_dropdown_options.length === 1 &&
                    <span data-tip={publish_dropdown_options[publish_dropdown_option_index].tooltip}>
                        {publish_dropdown_options[publish_dropdown_option_index].title}
                        <ReactTooltip />
                    </span>
                }
                { publish_dropdown_options.length > 1 &&
                    <ShareAccessModalButton
                        entity_info={{...props.event_info,entity_type:'events'}}
                        publish_dropdown_options={publish_dropdown_options}
                        publish_dropdown_option_index={publish_dropdown_option_index}
                        OnChangePublishOption={props.OnChangePublishOption}
                        index={props.index}
                        //button_text='Share'
                        //button_icon=<i className="fa fa-lock"/>
                    />
                }
                */}
                {/*
                { publish_dropdown_options.length > 0 &&
                    <ShareAccessModalButton
                        entity_info={{...props.event_info,entity_type:'events'}}
                        //publish_dropdown_options={publish_dropdown_options}
                        //publish_dropdown_option_index={publish_dropdown_option_index}
                        OnChangePublishOption={props.OnChangePublishOption}
                        index={props.index}
                    />
                }
                */}
                
                <ShareAccessModalButton
                    entity_info={{...props.event_info,entity_type:'events'}}
                    //publish_dropdown_options={publish_dropdown_options}
                    //publish_dropdown_option_index={publish_dropdown_option_index}
                    OnChangePublishOption={props.OnChangePublishOption}
                    index={props.index}
                />
                
            </td>


            <td className="">
                        <DownloadAssetsButton
                            entity_info={{...props.event_info,entity_type:'events'}}
                        />
                        {/*
                        <React.Fragment>
                            { assets_array.length > 0 &&
                                <DropdownButton
                                    //id="dropdown-basic-button"
                                    data-tip="Download File"
                                    title={<i className="fa fa-download"></i>}
                                    alignRight
                                    drop={'left'}
                                    size="sm"
                                >
                                {
                                    assets_array.map((item,index) => {
                                        return (
                                            <Dropdown.Item
                                                key={index}
                                                href={item.asset_url}
                                                rel="noopener noreferrer"
                                            >
                                                {item.dropdown_option}
                                            </Dropdown.Item>
                                        );
                                    })
                                }
                                    <ReactTooltip/>
                                </DropdownButton>
                            }
                        </React.Fragment>
                        */}
            
            </td>
            <td style={{ textAlign: "right" }} className="">
                {
                    props.event_info.editable ?
                        <React.Fragment>
                        <div>
                            <SplitButton
                                //data-tip={`Edit Presentation ${edit_dropdown_options[edit_dropdown_option_index].otherpage}`}
                                //className="btn-block"
                                //justified
                                style={{ width: "150px", fontSize: "smaller" }}
                                alignRight
                                size="sm"
                                //key={variant}
                                //id="dropdown-menu-align-right"
                                //id={`dropdown-split-variants-${variant}`}
                                //variant={'secondary'}
                                title={edit_dropdown_options[edit_dropdown_option_index].title}
                                //title={'Edit'}
                                drop={'left'}
                                onClick={() => onClickEditDropdown(edit_dropdown_option_index)}
                            >
                                {props.OnDeleteEvent &&
                                    <React.Fragment>
                                    <Dropdown.Item
                                        key={'delete'}
                                        onClick={() => onClickDeleteEvent()}
                                    >
                                        Delete Event
                                    </Dropdown.Item>
    
                                    <Dropdown.Divider />
                                    </React.Fragment>
                                }
                            {
                                edit_dropdown_options.map((item,index) => {
                                    if (index === edit_dropdown_option_index) {
                                        return <React.Fragment key={index}></React.Fragment>;
                                    }

                                    return (
                                        <Dropdown.Item
                                            //data-tip={`Edit Presentation ${edit_dropdown_options[index].otherpage}`}
                                            //id="dropdown-menu-align-right"
                                            //width="200px"
                                            key={index}
                                            onClick={() => onClickEditDropdown(index)}
                                        >
                                            {item.title}
                                        </Dropdown.Item>
                                    );
                                })
                            }
                                
                            </SplitButton>
                        </div>
                        <div>
                            <Modal size="sm" show={showConfirmModal} onHide={() => hideConfirmModal()} className="modal-contact-custom" >
                                <div>
                                    <ConfirmModal
                                        modalText={`The '${props.event_info.entity_name}' event will will be permanently deleted. Press 'Confirm Deletion' to continue.`}
                                        OnConfirmDelete={() => OnConfirmDelete()}
                                        hideConfirmModal={() => hideConfirmModal()}
                                    />
                                    <div>
                                        <Button theme="contact-button" OnClickMet={() => hideConfirmModal()}>
                                            x
                                        </Button>
                                    </div>
                                 </div>
                            </Modal>
                        </div>
                        </React.Fragment>
                    :
                        <React.Fragment>
                        </React.Fragment>
                }
            </td>
        </tr>
    );

    /*
    return (
        <tr>
            <td className="upComingEventName">
                {(props.event_info.status_code === 1) ?
                    <NavLink to={`${workspace_base_url}${local_routes.events}/${props.event_info.friendly_url}`}>
                        <div style={{color: '#007bff' }} className="React__checkbox">
                            <span className="label-value">{props.event_info.entity_name}</span>
                        </div>
                    </NavLink>
                :
                    <div style={{color: '#212529' }} className="React__checkbox">
                        <span className="label-value">{props.event_info.entity_name}</span>
                    </div>
    
                }
            </td>
            <td className="pkDate">
                {new Date(props.event_info.start_time * 1000).toLocaleDateString()}
            </td>
            <td className="pkDate">
                {source_text}
            </td>
            <td className="">
                <div className="">
                    <Form>
                        <Form.Group className="mb-0">
                            <div className="">
                                <label className="check-box">
                                    <input type="checkbox"
                                        disabled={false}
                                        className="React__checkbox--input"
                                        name="public_status"
                                        onChange={() => onPublishedCheckboxSelect('isPublishedChecked')}
                                        checked={isPublishedChecked} />
                                    <span className="React__checkbox--span" />
                                    <span className="label-value"></span>
                                </label>                           
 
                            </div>
                        </Form.Group>
                    </Form>
                </div>
            </td>
            { workspace_base_url &&
            <td className="">
                {   (true === true) ? // change this to enable upsell
                    <React.Fragment>
                        { assets_array.length > 0 &&
                            <DropdownButton
                                //id="dropdown-basic-button"
                                data-tip="Download File"
                                title={<i className="fa fa-download"></i>}
                                alignRight
                                drop={'left'}
                                size="sm"
                            >
                            {
                                assets_array.map((item,index) => {
                                    return (
                                        <Dropdown.Item
                                            key={index}
                                            href={item.asset_url}
                                            rel="noopener noreferrer"
                                        >
                                            {item.dropdown_option}
                                        </Dropdown.Item>
                                    );
                                })
                            }
                                <ReactTooltip />
                            </DropdownButton>
                        }
                    </React.Fragment>
                    :
                    <React.Fragment>
                        <span data-tip="Upgrade to PK Create Pro to Download Your Presentation">
                            <i className="fa fa-download"></i>
                        </span>
                        <ReactTooltip />
                    </React.Fragment>
                }
            </td>
            }
            <td style={{ textAlign: "right" }} className="">
                {
                    props.event_info.editable ?
                        <React.Fragment>
                        <div>
                            <SplitButton
                                //data-tip={`Edit Presentation ${edit_dropdown_options[edit_dropdown_option_index].otherpage}`}
                                //className="btn-block"
                                //justified
                                style={{ width: "150px", fontSize: "smaller" }}
                                alignRight
                                size="sm"
                                //key={variant}
                                //id="dropdown-menu-align-right"
                                //id={`dropdown-split-variants-${variant}`}
                                //variant={'secondary'}
                                title={edit_dropdown_options[edit_dropdown_option_index].title}
                                //title={'Edit'}
                                drop={'left'}
                                onClick={() => onClickEditDropdown(edit_dropdown_option_index)}
                            >
                                {props.OnDeleteEvent &&
                                    <React.Fragment>
                                    <Dropdown.Item
                                        key={'delete'}
                                        onClick={() => onClickDeleteEvent()}
                                    >
                                        Delete Event
                                    </Dropdown.Item>
    
                                    <Dropdown.Divider />
                                    </React.Fragment>
                                }
                            {
                                edit_dropdown_options.map((item,index) => {
                                    if (index === edit_dropdown_option_index) {
                                        return <React.Fragment key={index}></React.Fragment>;
                                    }

                                    return (
                                        <Dropdown.Item
                                            //data-tip={`Edit Presentation ${edit_dropdown_options[index].otherpage}`}
                                            //id="dropdown-menu-align-right"
                                            //width="200px"
                                            key={index}
                                            onClick={() => onClickEditDropdown(index)}
                                        >
                                            {item.title}
                                        </Dropdown.Item>
                                    );
                                })
                            }
                                
                            </SplitButton>
                        </div>
                        <div>
                            <Modal size="sm" show={showConfirmModal} onHide={() => hideConfirmModal()} className="modal-contact-custom" >
                                <div>
                                    <ConfirmModal
                                        modalText={`The '${props.event_info.entity_name}' event will will be permanently deleted. Press 'Confirm Deletion' to continue.`}
                                        OnConfirmDelete={() => OnConfirmDelete()}
                                        hideConfirmModal={() => hideConfirmModal()}
                                    />
                                    <div>
                                        <Button theme="contact-button" OnClickMet={() => hideConfirmModal()}>
                                            x
                                        </Button>
                                    </div>
                                 </div>
                            </Modal>
                        </div>
                        </React.Fragment>
                    :
                        <React.Fragment>
                        </React.Fragment>
                }
            </td>
        </tr>
    );
    */
}
export default withRouter(EventListV2);



